import { TEXT_FIELD_SETTING } from '@/constants/elements/text-field';
import { EMAIL_FIELD_SETTING } from '@/constants/elements/email-field';
import { TEXT_AREA_SETTING } from '@/constants/elements/text-area';
import { DROPDOWN_SETTING } from '@/constants/elements/dropdown';
import { CHECKBOX_SETTING } from '@/constants/elements/checkbox';
import { SUBMIT_BUTTON_SETTING } from '@/constants/elements/submit-button';

export const SETTING_FORM_FIELDS = {
  'text-field': TEXT_FIELD_SETTING,
  'email-field': EMAIL_FIELD_SETTING,
  'text-area': TEXT_AREA_SETTING,
  dropdown: DROPDOWN_SETTING,
  checkbox: CHECKBOX_SETTING,
  'submit-button': SUBMIT_BUTTON_SETTING,
};
